// lenis smooth scroll
const lenis = new Lenis({
  smoothWheel: true, // Smooth wheel behavior
  smoothTouch: false, // Disable smooth touch scrolling (if needed)
  normalizeWheel: true, // Normalize wheel events
  ignore: (el) => el.classList.contains("scroll-section"),
});

lenis.on("scroll", ScrollTrigger.update);

gsap.ticker.add((time) => {
  lenis.raf(time * 700);
});

gsap.ticker.lagSmoothing(0);

lenis.on("scroll", ScrollTrigger.update);

gsap.ticker.add((time) => {
  lenis.raf(time * 700);
});

gsap.ticker.lagSmoothing(0);

// lenis scroll end

// ========== prevent zooming ==========

document.addEventListener('gesturestart', function (e) {
  e.preventDefault();
  body.style.touchAction = "none";
});

// ========== prevent zooming ==========

document.querySelector("#openPopupButton").addEventListener("click", () => {
  document.querySelector(".overlay").style.display = "flex";
});
function updateIndianTime() {
  const options = {
    timeZone: "Asia/Kolkata",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: true,
  };

  const indianTime = new Date().toLocaleTimeString("en-IN", options);
  const timeElements = document.getElementsByClassName("i-time");

  // Convert HTMLCollection to an array and update each element
  Array.from(timeElements).forEach((element) => {
    element.textContent = `[ INDIA ${indianTime} ]`;
  });
}

// Initial call to update time immediately
updateIndianTime();

// Update time every second
setInterval(updateIndianTime, 1000);

window.showTab = function (tabId, clickedElement) {
  // console.log("Tab clicked: " + tabId);

  let parentElement = clickedElement.parentElement;

  // Handle Size Guide Tabs Separately
  if (clickedElement.classList.contains("size2-tab")) {
    document
      .querySelectorAll(".size2-tab")
      .forEach((tab) => tab.classList.remove("active"));
    clickedElement.classList.add("active");

    document
      .querySelectorAll(".chart-container")
      .forEach((chart) => chart.classList.remove("active"));
    document.getElementById(tabId).classList.add("active");

    return; // Exit function to prevent interference
  }

  // Remove 'active' class from all <li> elements in the parent <ul>
  if (parentElement.nodeName !== "LI") {
    parentElement
      .querySelectorAll("li")
      .forEach((item) => item.classList.remove("active"));
    clickedElement.classList.add("active");
  } else {
    parentElement.parentElement.querySelectorAll("li").forEach((item) => {
      item.querySelector("a").classList.remove("active");
    });
    clickedElement.classList.add("active");
  }

  // Function to Close Other Tabs in the Group
  function closeTabView(group, tabId) {
    group.forEach((id) => {
      let tab = document.getElementById(id);
      if (tab) tab.classList.remove("active");
    });
    document.getElementById(tabId).classList.add("active");
  }

  // Define Tab Groups
  const tabGroups = {
    product: ["tab1", "tab2", "tab3"],
    cart: ["tab51", "tab52"],
    mobile: ["tab101", "tab102", "tab103", "tab104"],
  };

  // Detect the group of the clicked tab
  for (let group in tabGroups) {
    if (tabGroups[group].includes(tabId)) {
      console.log(`Switching ${group} tabs`);
      closeTabView(tabGroups[group], tabId);
      return;
    }
  }

  console.log("No matching tab group found.");
};

// function openPopup() {
//   document.getElementById("overlay").style.display = "flex";
//   document.addEventListener("keydown", handleKeyDown);

//   // Add click event listener to the overlay
//   document.getElementById("overlay").addEventListener("click", closePopup);
// }

// function closePopup(event) {
//   if (event.type === "click" || event.key === "Escape") {
//     // Check if the click is on the overlay itself, not the popup content
//     if (
//       event.type === "click" &&
//       event.target === document.getElementById("overlay")
//     ) {
//       document.getElementById("overlay").style.display = "none";
//       document.removeEventListener("keydown", handleKeyDown);
//       document
//         .getElementById("overlay")
//         .removeEventListener("click", closePopup);
//     }
//     // Handle the Escape key press
//     else if (event.key === "Escape") {
//       document.getElementById("overlay").style.display = "none";
//       document.removeEventListener("keydown", handleKeyDown);
//       document
//         .getElementById("overlay")
//         .removeEventListener("click", closePopup);
//     }
//   }
// }

const closeSub = document.querySelector(".popupClose");
const overlay = document.getElementById("overlay");

// // Check if popup was previously closed
// if (localStorage.getItem("popupClosed") === "true") {
//   overlay.style.display = "none";
// }

// // Close popup and store the state
closeSub.addEventListener("click", () => {
  overlay.style.display = "none";
  localStorage.setItem("popupClosed", "true");
});

function handleKeyDown(event) {
  if (event.key === "Escape") {
    closePopup(event);
  }
}

// Function for Opening Tabs with Transition Effect
function openTab(event, tabName) {
  console.log("Opening Tab: " + tabName);

  // Hide all tab content using max-height transition
  const allTabs = document.querySelectorAll(".s5s-p-tab-content");
  allTabs.forEach((tab) => {
    tab.style.maxHeight = "0px"; // Collapse the tab content
    tab.classList.remove("active"); // Remove active class
  });

  // Remove 'active' class from all tab buttons
  document
    .querySelectorAll(".s5s-p-tab")
    .forEach((button) => button.classList.remove("active"));

  // Show the clicked tab's content
  const currentTab = document.getElementById(tabName);
  if (currentTab) {
    currentTab.style.maxHeight = currentTab.scrollHeight + "px"; // Expand smoothly
    currentTab.classList.add("active");
  }

  // Add 'active' class to the clicked tab button
  event.currentTarget.classList.add("active");
}

function openTab(event, tabName) {
  // Hide all tab content with max-height transition
  const allTabs = document.querySelectorAll(".s5s-p-tab-content");
  allTabs.forEach((tab) => {
    tab.style.maxHeight = "0"; // Collapse the tab content
  });

  // Remove the active class from all tabs
  const allTabButtons = document.querySelectorAll(".s5s-p-tab");
  allTabButtons.forEach((button) => button.classList.remove("active"));

  // Show the clicked tab's content
  const currentTab = document.getElementById(tabName);
  currentTab.style.maxHeight = currentTab.scrollHeight + "px"; // Set max-height to content's height

  // Add the active class to the clicked tab button
  event.currentTarget.classList.add("active");
}

// // Set default tab (Tab 1) to be open on page load
document.addEventListener("DOMContentLoaded", () => {
  const firstTab = document.querySelector(".s5s-p-tab");
  if (firstTab) {
    firstTab.click(); // Simulate click on the first tab
  }
});

// size chart start

// function openSizeBox() {
//     const sizeboxMenu = document.querySelector('.size-box');

//     sizeboxMenu.classList.toggle("size-box-active");

//     // Add event listener for scroll
//     document.addEventListener('scroll', closeSizeBoxOnScroll);
// }

// function closeSizeBoxOnScroll() {
//     const sizeboxMenu = document.querySelector('.size-box');
//     const relatedProducts = document.querySelector('.related-products');

//     const sizeboxPosition = sizeboxMenu.getBoundingClientRect();
//     const relatedProductsPosition = relatedProducts.getBoundingClientRect();

//     if (sizeboxPosition.bottom >= relatedProductsPosition.top) {
//         sizeboxMenu.classList.remove("size-box-active");
//         document.removeEventListener('scroll', closeSizeBoxOnScroll);
//     }
// }

// for search aniation

// Toggle search container visibility and change text for #searchLink1
// document.addEventListener('DOMContentLoaded', function () {
//   var searchLinks = document.querySelectorAll('.searchLink'); // Select all search links
//   var closeButtons = document.querySelectorAll('.close-button'); // Select all close buttons
//   var searchContainer = document.querySelector('.s5s-search-container');

//   // Select only the specific <a> elements inside <li>
//   var hoverItems = document.querySelectorAll('.teamwear, .activewear, .streetwear, .c-shop');

//   // Function to toggle search on click
//   searchLinks.forEach(function (searchLink) {
//     searchLink.addEventListener('click', function (event) {
//       event.preventDefault(); // Prevent default behavior

//       if (!searchContainer) return;

//       // Toggle the class on the search container
//       var isActive = searchContainer.classList.toggle('e-search');

//       if (isActive) {
//         searchContainer.classList.add('e-search-active');
//         this.innerHTML = 'CLOSE'; // Change to CLOSE
//         this.style.color = "#F15A22";
//       } else {
//         searchContainer.classList.remove('e-search-active');
//         this.innerHTML = 'SEARCH'; // Change back to SEARCH
//         this.style.color = "#000";
//       }
//     });

//     // Hover effect for search link
//     searchLink.addEventListener('mouseenter', function () {
//       if (!searchContainer.classList.contains('e-search-active')) {
//         searchContainer.classList.add('e-search');
//         this.innerHTML = 'CLOSE';
//         this.style.color = "#F15A22";
//       }
//     });

//     searchLink.addEventListener('mouseleave', function () {
//       if (!searchContainer.classList.contains('e-search-active')) {
//         searchContainer.classList.remove('e-search');
//         this.innerHTML = 'SEARCH';
//         this.style.color = "#000";
//       }
//     });
//   });

//   // Hover effect for only the specified <a> elements inside <li>
//   hoverItems.forEach(function (hoverItem) {
//     hoverItem.addEventListener('mouseenter', function () {
//       if (!searchContainer.classList.contains('e-search-active')) {
//         searchContainer.classList.add('e-search');
//       }
//     });

//     hoverItem.addEventListener('mouseleave', function () {
//       if (!searchContainer.classList.contains('e-search-active')) {
//         searchContainer.classList.remove('e-search');
//       }
//     });
//   });

//   // Close button functionality
//   closeButtons.forEach(function (closeButton) {
//     closeButton.addEventListener('click', function () {
//       if (!searchContainer) return;

//       // Remove both classes
//       searchContainer.classList.remove('e-search', 'e-search-active');

//       // Reset text and color for all search links
//       searchLinks.forEach(function (searchLink) {
//         searchLink.innerHTML = 'SEARCH';
//         searchLink.style.color = "#000";
//       });
//     });
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  var searchLinks = document.querySelectorAll(".searchLink");
  var closeButtons = document.querySelectorAll(".close-button");
  var searchContainer = document.querySelector(".s5s-search-container");
  var cartDrawer = document.querySelector(".drawer");
  var cartBtn = document.querySelector(".free-shipping");
  searchLinks.forEach(function (searchLink) {
    const originalHTML = searchLink.innerHTML; // Store the original content

    searchLink.addEventListener("click", function (event) {
      event.preventDefault();

      if (!searchContainer) return;

      searchContainer.classList.toggle("e-search");

      if (searchContainer.classList.contains("e-search")) {
        this.innerHTML = "CLOSE"; // Change to CLOSE
        this.style.color = "#F15A22";
        cartDrawer.classList.remove("active");
      } else {
        this.innerHTML = originalHTML; // Restore the original content
        this.style.color = "#000";
      }
      cartBtn.addEventListener("click", () => {
        searchContainer.classList.remove("e-search");
        searchLink.textContent = "SEARCH";
        searchLink.style.color = "#000";
      });
    });
  });

  closeButtons.forEach(function (closeButton) {
    closeButton.addEventListener("click", function (event) {
      if (!searchContainer) return;

      searchContainer.classList.remove("e-search");

      searchLinks.forEach(function (searchLink) {
        searchLink.innerHTML =
          searchLink.dataset.original || searchLink.innerHTML;
        searchLink.style.color = "#000";
      });
    });
  });
});

// codding is remaining this search container code has little bugs

// footer accordion  start
document.querySelectorAll(".f-navlist p").forEach(function (pTag) {
  pTag.addEventListener("click", function () {
    const parentUl = pTag.parentElement; // Assuming 'col2' is the parent
    const contentWrapper = parentUl.querySelector("ul"); // Get the corresponding ul

    // Check if already active
    const isActive = parentUl.classList.contains("open");

    // Collapse all sections
    document.querySelectorAll(".f-navlist").forEach(function (item) {
      item.classList.remove("open");
      const ul = item.querySelector("ul");
      if (ul) {
        ul.style.maxHeight = "0"; // Collapse
      }
    });

    // Expand the clicked section if it's not active
    if (!isActive) {
      parentUl.classList.add("open");
      if (contentWrapper) {
        contentWrapper.style.maxHeight = contentWrapper.scrollHeight + "px"; // Set maxHeight to the scrollHeight
      }
    }
  });
});
// footer accordion  end

document.addEventListener("DOMContentLoaded", function () {
  const navbar = document.querySelector(".collection-sticky-nevbar");
  const menuList = document.querySelector(".collection-sticky-menu ul");

  if (navbar && menuList) {
    window.addEventListener("scroll", function () {
      const rect = navbar.getBoundingClientRect();
      if (rect.top <= 100) {
        menuList.style.flexWrap = "nowrap";
      } else {
        menuList.style.flexWrap = "wrap";
      }
    });
  } else {
    console.warn("Navbar or menu list not found.");
  }
});

// document.addEventListener("DOMContentLoaded", function () {
//   const openBtns = document.querySelectorAll(".customize-tee-button");
//   const popup = document.querySelector(".customize-popup");
//   const popupContent = document.querySelector(".popup-content");
//   const confirmBtn = document.querySelector(".confirm-btn");
//   const nameInput = document.querySelector(".name-input");
//   const numberInput = document.querySelector(".number-input");
//   const customNameField = document.getElementById("custom-name-field");
//   const customNumberField = document.getElementById("custom-number-field");
//   const closeBtn = document.querySelector(".c-pop-svg"); // Close button

//   // Get all radio buttons
//   const blankOption = document.querySelector("input[value='BLANK']");
//   const nameOption = document.querySelector("input[value='NAME']");
//   const numberOption = document.querySelector("input[value='NUMBER']");
//   const nameNumberOption = document.querySelector("input[value='NAME AND NUMBER']");
//   let typingTimer;
//   const typingDelay = 800;
// function selectVariant(option) {
//        option.click();
//       option.dispatchEvent(new Event("change", { bubbles: true }));
//   }

//   function updateSelection() {
//     clearTimeout(typingTimer);
//     typingTimer = setTimeout(() => {
//       selectVariant(blankOption)
//       const name = nameInput.value.trim();
//       const number = numberInput.value.trim();
//       if (name && number) {
//         selectVariant(nameNumberOption);
//       } else if (name) {
//         selectVariant(nameOption);
//       } else if (number) {
//         selectVariant(numberOption);
//       }else{
//         selectVariant(blankOption);
//       }
//     }, typingDelay);
//   }
//   // add to cart button in cart-drawer

//   nameInput.addEventListener("input", function () {
//     if (this.value.length > 13) {
//       this.value = this.value.substring(0, 13);
//     }
//   });
//   numberInput.addEventListener("input", function () {
//     this.value = this.value.replace(/\D/g, "");
//     if (this.value.length > 3) {
//       this.value = this.value.substring(0, 3);
//     }
//   });
// //    document.querySelectorAll(".product-form__input input").forEach(el=>{
// //      console.log(el)
// //      el.disabled = true
// // })

// //    document.querySelector(".form-label-container").forEach(el=>{
// // }).addEventListener("click", function () {
// //     document.querySelector(".product-price").innerHTML = "55"
// //   }
//   openBtns.forEach((btn) => {
//     btn.addEventListener("click", () => {
//       popup.classList.add("open");
//     });
//   });

//   // Close popup when clicking outside content
//   popup.addEventListener("click", (event) => {
//     if (!popupContent.contains(event.target)) {
//       popup.classList.remove("open");
//     }
//   });

//   // Close popup when clicking on the close button
//   if (closeBtn) {
//     closeBtn.addEventListener("click", () => {
//       popup.classList.remove("open");
//     });
//   }

//   nameInput.addEventListener("input", updateSelection);
//   numberInput.addEventListener("input", updateSelection);

//   confirmBtn.addEventListener("click", () => {
//     customNameField.value = nameInput.value.trim();
//     customNumberField.value = numberInput.value.trim();
//     // updateSelection()
//     popup.classList.remove("open");
//   });
// });

////////////////////////// Magic Code Start /////////////////////////////////
// document.addEventListener("DOMContentLoaded", function () {



  
//   const section = document.querySelector(".product__info-container");
//   if (!section) return;

//   // Elements
//   const addToCartBtn = section.querySelector(".product-form__submit");
//   const openBtns = section.querySelectorAll(".customize-tee-button");
//   const popup = section.querySelector(".customize-popup");
//   const popupContent = section.querySelector(".popup-content");
//   const confirmBtn = popupContent?.querySelector(".confirm-btn");
//   const nameInput = section.querySelector(".name-input");
//   const numberInput = section.querySelector(".number-input");
//   const customNameField = document.getElementById("custom-name-field");
//   const customNumberField = document.getElementById("custom-number-field");
//   const closeBtn = section.querySelector(".c-pop-svg");

//   // Radio Options
//   const radioOptions = {
//     blank: section.querySelector("input[value='BLANK']"),
//     name: section.querySelector("input[value='NAME']"),
//     number: section.querySelector("input[value='NUMBER']"),
//     both: section.querySelector("input[value='NAME AND NUMBER']"),
//   };


// function updateVariantSelection() {
//   const variantSelector = section.querySelector('.single-option-selector');
//   let desiredOption = '';

//   const nameVal = nameInput.value.trim();
//   const numberVal = numberInput.value.trim();

//   if (nameVal && numberVal) {
//     desiredOption = 'NAME AND NUMBER';
//   } else if (nameVal) {
//     desiredOption = 'NAME';
//   } else if (numberVal) {
//     desiredOption = 'NUMBER';
//   } else {
//     desiredOption = 'BLANK';
//   }

//   if (variantSelector) {
//     for (let i = 0; i < variantSelector.options.length; i++) {
//       const optionText = variantSelector.options[i].textContent || variantSelector.options[i].innerText;
//       if (optionText.trim().toUpperCase() === desiredOption) {
//         variantSelector.selectedIndex = i;
//         variantSelector.dispatchEvent(new Event('change', { bubbles: true }));
//         break;
//       }
//     }
//   }
// }




  
//   /**
//    * Update radio based on inputs
//    */
//   function updateRadioSelection() {
//     const nameVal = nameInput.value.trim();
//     const numberVal = numberInput.value.trim();
  
//     if (nameVal && numberVal) {
//       selectRadio(radioOptions.both);
//         console.log(radioOptions.both);
//     } else if (nameVal) {
//       selectRadio(radioOptions.name);
//     } else if (numberVal) {
//       selectRadio(radioOptions.number);
//     } else {
//       selectRadio(radioOptions.blank);
//     }

//     updateVariantSelection(); 
//     popup.classList.remove("open");

//     if (customNameField) customNameField.value = nameVal;
//     if (customNumberField) customNumberField.value = numberVal;
//   }

// //   function updateRadioSelection() {
// //     const nameVal = nameInput.value.trim();
// //     const numberVal = numberInput.value.trim();

// //     if (nameVal && numberVal) {
// //         selectRadio(radioOptions.both);
// //         console.log('Selected: NAME AND NUMBER');
// //     } else if (nameVal) {
// //         selectRadio(radioOptions.name);
// //         console.log('Selected: NAME');
// //         if (customNumberField) customNumberField.value = ''; // clear number
// //     } else if (numberVal) {
// //         selectRadio(radioOptions.number);
// //         console.log('Selected: NUMBER');
// //         if (customNameField) customNameField.value = ''; // clear name
// //     } else {
// //         selectRadio(radioOptions.blank);
// //         console.log('Selected: BLANK');
// //         if (customNameField) customNameField.value = '';
// //         if (customNumberField) customNumberField.value = '';
// //     }

// //     updateVariantSelection();
// //     popup.classList.remove("open");

// //     if (customNameField) customNameField.value = nameVal;
// //     if (customNumberField) customNumberField.value = numberVal;
// // }


//   function selectRadio(radio) {
//     if (!radio) return;
//     radio.checked = true;
//     radio.dispatchEvent(new Event("change", { bubbles: true }));
//   }

//   // Open popup
//   openBtns.forEach((btn) => {
//     btn.addEventListener("click", () => popup.classList.add("open"));
//   });

//   //open popup by nilesh
// //  openBtns.forEach((btn) => {
// //     btn.addEventListener("click", () => {
// //         localStorage.setItem('openPopupAfterReload', 'true');
// //         window.location.reload();
// //     });
// // });

// // window.addEventListener("load", () => {
// //     if (localStorage.getItem('openPopupAfterReload') === 'true') {
// //         localStorage.removeItem('openPopupAfterReload');
// //         setTimeout(() => {
// //             popup.classList.add("open");
// //         }, 800);
// //     }
// // });
  
//     //open popup by nilesh
// //   openBtns.forEach((btn) => {
// //     btn.addEventListener("click", () => {
// //         localStorage.setItem('openPopupAfterReload', 'true');
// //         window.location.reload();
// //     });
// // });

// // window.addEventListener("load", () => {
// //     if (localStorage.getItem('openPopupAfterReload') === 'true') {
// //         localStorage.removeItem('openPopupAfterReload');

// //         const loading = document.querySelector('.popup-loading');
// //         const popup = document.querySelector(".customize-popup");

// //         if (loading) loading.style.display = 'block';

// //         setTimeout(() => {
// //             if (loading) loading.style.display = 'none';
// //             if (popup) popup.classList.add("open");
// //         }, 800);
// //     }
// // });


  

//   // Close popup on outside click
//   popup.addEventListener("click", (e) => {
//     if (!popupContent.contains(e.target)) {
//       popup.classList.remove("open");
//     }
//   });

//   // Close popup via close button
//   closeBtn?.addEventListener("click", (e) => {
//     e.stopPropagation();
//     popup.classList.remove("open");
//   });

//   // Confirm customization
//   confirmBtn?.addEventListener("click", (e) => {
//     e.preventDefault();
//     updateRadioSelection();

//     // Add to cart after short delay
//     setTimeout(() => {
//          addToCartBtn?.click();
//       // After another short delay, reset to BLANK
//          setTimeout(() => {
//              resetAddOnToBlank();
//          }, 1000); 
//     }, 1500);     
//   });

   
// //NILESH CODES HERE

//   // ✅ Listen for SIZE change and trigger Shopify variant update
//   // const sizeSelector = document.querySelector("select[name='option-0']");
//   // sizeSelector?.addEventListener("change", function () {
//   //   const event = new Event('change', { bubbles: true });
//   //   sizeSelector.dispatchEvent(event);
//   //   console.log('Size changed, Shopify variant update triggered.');
//   //    If needed, you can also call location.reload(); here, but Shopify usually handles it.
//   // });


    
//   // Name input validation
//   nameInput?.addEventListener("input", function () {
//     if (this.value.length > 13) {
//       this.value = this.value.slice(0, 13);
//     }
//   });


//   // NILESH CODE THAT REFRESH THE SECOND VARIANT ==>> THIS PART NEEDS TO CHECK ON HTML RENDER input[name^='ADD ON-2'][value='BLANK]
//   function resetAddOnToBlank() {
//     const blankAddonRadio = section.querySelector("input[name^='ADD ON-2'][value='BLANK']");
//     if (blankAddonRadio) {
//         blankAddonRadio.checked = true;
//         blankAddonRadio.dispatchEvent(new Event('change', { bubbles: true }));
//         console.log("✅ ADD ON reset to BLANK.");
//     }

//    if (nameInput) nameInput.value = '';
//     if (numberInput) numberInput.value = '';

//     if (customNameField) customNameField.value = '';
//     if (customNumberField) customNumberField.value = '';
// }

//   // Number input validation
//   numberInput?.addEventListener("input", function () {
//     this.value = this.value.replace(/\D/g, "").slice(0, 3);
//   });
// });


////////////////////////// Magic Code End ///////////////////////////////////


////////////////// new magic code by NILESH ////////////////

document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".product__info-container");
  if (!section) return;

  const addToCartBtn = section.querySelector(".product-form__submit");
  const openBtns = section.querySelectorAll(".customize-tee-button");
  const popup = section.querySelector(".customize-popup");
  const popupContent = section.querySelector(".popup-content");
  const confirmBtn = popupContent?.querySelector(".confirm-btn");
  const nameInput = section.querySelector(".name-input");
  const numberInput = section.querySelector(".number-input");
  const customNameField = document.getElementById("custom-name-field");
  const customNumberField = document.getElementById("custom-number-field");
  const closeBtn = section.querySelector(".c-pop-svg");

  function updateVariantSelection() {
    const nameVal = nameInput.value.trim();
    const numberVal = numberInput.value.trim();
    let desiredOption = '';

    if (nameVal && numberVal) {
      desiredOption = 'NAME AND NUMBER';
    } else if (nameVal) {
      desiredOption = 'NAME';
    } else if (numberVal) {
      desiredOption = 'NUMBER';
    } else {
      desiredOption = 'BLANK';
    }

    const addonRadio = section.querySelector(`input[name^='ADD ON-2'][value='${desiredOption}']`);
    if (addonRadio) {
      addonRadio.checked = true;
      addonRadio.dispatchEvent(new Event('change', { bubbles: true }));
      console.log(`✅ Selected ADD ON: ${desiredOption}`);
    }
  }

  function updateRadioSelection() {
    updateVariantSelection();
    popup.classList.remove("open");

    if (customNameField) customNameField.value = nameInput.value.trim();
    if (customNumberField) customNumberField.value = numberInput.value.trim();
  }

  function selectRadio(radio) {
    if (!radio) return;
    radio.checked = true;
    radio.dispatchEvent(new Event("change", { bubbles: true }));
  }

  function resetAddOnToBlank() {
    const blankAddonRadio = section.querySelector("input[name^='ADD ON-2'][value='BLANK']");
    if (blankAddonRadio) {
      blankAddonRadio.checked = true;
      blankAddonRadio.dispatchEvent(new Event('change', { bubbles: true }));
      console.log("✅ ADD ON reset to BLANK.");
    }

    if (nameInput) nameInput.value = '';
    if (numberInput) numberInput.value = '';
    if (customNameField) customNameField.value = '';
    if (customNumberField) customNumberField.value = '';
  }

  // Open popup
  openBtns.forEach((btn) => {
    btn.addEventListener("click", () => popup.classList.add("open"));
  });

  // Close popup on outside click
  popup.addEventListener("click", (e) => {
    if (!popupContent.contains(e.target)) {
      popup.classList.remove("open");
    }
  });

  // Close popup via close button
  closeBtn?.addEventListener("click", (e) => {
    e.stopPropagation();
    popup.classList.remove("open");
  });

  // Confirm customization
  confirmBtn?.addEventListener("click", (e) => {
    e.preventDefault();
    updateRadioSelection();

    setTimeout(() => {
      addToCartBtn?.click();
      setTimeout(() => {
        resetAddOnToBlank();
      }, 1000);
    }, 1500);
  });

  // Name input validation
  nameInput?.addEventListener("input", function () {
    if (this.value.length > 13) {
      this.value = this.value.slice(0, 13);
    }
  });

  // Number input validation
  numberInput?.addEventListener("input", function () {
    this.value = this.value.replace(/\D/g, "").slice(0, 3);
  });
});



////////////////// ENDS new magic code by NILESH ////////////////





function openSizeBox() {
  document.querySelector(".size-2-body-container").classList.add("up");
}

function removeGuide() {
  document.querySelector(".size-2-body-container").classList.remove("up");
}

// document.querySelector(".size-2-body-container").addEventListener("click", e => {
//   if (!e.target.closest(".size-2-guide-container")) removeGuide();
// });

document.addEventListener("DOMContentLoaded", function () {


// const variantSelects = document.querySelector('#variant-selects-template--16624485072962__main');

// variantSelects.addEventListener('change', function (e) {
//   if (e.target && e.target.name === 'SIZE-1') {
//     console.log(`Size selected: ${e.target.value}`);
//     location.reload();
//   }
// });
  
  const drawer = document.querySelector(".drawer");

  function toggleBodyOverflow() {
    if (
      drawer.classList.contains("animate") &&
      drawer.classList.contains("active")
    ) {
      document.body.classList.add("h-overflow");
    } else {
      document.body.classList.remove("h-overflow");
    }
  }

  // Listen for class changes on .drawer
  const observer = new MutationObserver(toggleBodyOverflow);
  observer.observe(drawer, { attributes: true, attributeFilter: ["class"] });

  // Run once on page load
  toggleBodyOverflow();
});

function showSizeGuide(unit) {
  // Remove 'active' class from all options
  document
    .querySelectorAll(".size2-option")
    .forEach((option) => option.classList.remove("active"));

  // Remove 'active' class from all chart containers
  document
    .querySelectorAll(".chart-container")
    .forEach((chart) => chart.classList.remove("active"));

  // Add 'active' class to the clicked option
  document
    .querySelector(`.size2-option[onclick="showSizeGuide('${unit}')"]`)
    .classList.add("active");

  // Show the corresponding chart
  document.getElementById(unit).classList.add("active");
}

// ------ Dev04 changes ------

// ------------------------
// grid with more space bug
// ------------------------

document.addEventListener("DOMContentLoaded", function () {
  const productGrid = document.getElementById("product-grid");  
  const productCount = productGrid.querySelectorAll(".grid__item").length;
  const vid2Element = productGrid.querySelector(".e-vid-2");
  const vid3Element = productGrid.querySelector(".e-vid-3");
  const vid4Element = productGrid.querySelector(".e-vid-4");

  function toggleVisibility(element, shouldShow, className = "hide-element") {
    if (element) {
      if (shouldShow) {
        element.classList.remove(className);
      } else {
        element.classList.add(className);
      }
    }
  }

  if (productCount <= 7 && vid2Element) {
    toggleVisibility(vid2Element, false);
  } else if (vid2Element) {
    toggleVisibility(vid2Element, true);
  }

  if (productCount <= 14 && vid3Element) {
    toggleVisibility(vid3Element, false);
  } else if (vid3Element) {
    toggleVisibility(vid3Element, true);
  }

  if (productCount <= 15 && vid4Element) {
    toggleVisibility(vid4Element, false);
  } else if (vid4Element) {
    toggleVisibility(vid4Element, true);
  }

  const style = document.createElement("style");
  style.innerHTML = `
      .hide-element {
        display: none !important;
      }
    `;
  document.head.appendChild(style);
});

// ------------------------
// grid with more space bug
// ------------------------

// ------ Cart Close changes ------
const drawer = document.querySelector(".drawer");
function handleClickOutside(event) {
  if (!drawer.contains(event.target)) {
    if (drawer.classList.contains("active")) {
      event.preventDefault();
      drawer.classList.remove("active");
      
    }
  }
}
document.addEventListener("click", handleClickOutside);
// ------ Cart Close changes END------

// --------- DEV 05 ----------------

// --------- Draggable Scroll JS ---------

function initDragToScroll(container) {
  if (!container) return;

  let isDragging = false;
  let startX = 0;
  let scrollLeft = 0;
  let currentX = 0;
  let rafId = null;
  let hasDragged = false;
  const dragThreshold = 5;

  // Prevent images from being dragged
  container.querySelectorAll("img").forEach((img) => {
    img.setAttribute("draggable", "false");
  });

  // Disable or enable anchor interactions and text selection
  const toggleAnchors = (disable) => {
    container.querySelectorAll("a").forEach((anchor) => {
      anchor.style.pointerEvents = disable ? "none" : "";
      anchor.style.userSelect = disable ? "none" : "";
    });
  };

  // Toggle text selection on the container itself
  const toggleContainerSelection = (disable) => {
    container.style.userSelect = disable ? "none" : "";
  };

  // Smoothly update scroll position while dragging
  const smoothScroll = () => {
    if (!isDragging) return;

    const distance = currentX - startX;

    if (Math.abs(distance) > dragThreshold && !hasDragged) {
      hasDragged = true;
      toggleAnchors(true);
      toggleContainerSelection(true);
    }

    container.scrollLeft = scrollLeft - distance;
    rafId = requestAnimationFrame(smoothScroll);
  };

  const startDragging = (e) => {
    const target = e.target;
    if (target.closest("input, textarea, select, button ,.confirm-btn")) return; // Skip form elements
    isDragging = true;
    hasDragged = false;
    startX = e.pageX;
    currentX = startX;
    scrollLeft = container.scrollLeft;

    e.preventDefault(); // Prevent text selection
    container.classList.add("dragging");

    cancelAnimationFrame(rafId);
    rafId = requestAnimationFrame(smoothScroll);
  };

  const stopDragging = () => {
    isDragging = false;
    container.classList.remove("dragging");
    cancelAnimationFrame(rafId);

    // Re-enable interactions after drag ends
    setTimeout(() => {
      toggleAnchors(false);
      toggleContainerSelection(false);
      hasDragged = false;
    }, 0);
  };

  // Event listeners
  container.addEventListener("mousedown", startDragging);
  container.addEventListener("mousemove", (e) => {
    if (isDragging) {
      currentX = e.pageX;
    }
  });
  container.addEventListener("mouseup", stopDragging);
  container.addEventListener("mouseleave", stopDragging);

  // Prevent link clicks if dragged
  container.addEventListener("click", (e) => {
    if (hasDragged) {
      e.preventDefault();
      e.stopPropagation();
    }
  });
}

// Initialize drag-to-scroll on all sliders
document.addEventListener("DOMContentLoaded", () => {
  // Custome Scroll
  initDragToScroll(document.querySelector(".s5s_collection_slider"));
  initDragToScroll(document.querySelector(".c-info-varient"));

  // Shopify Product Scroll Use This
  const sliders = document.querySelectorAll(".grid");
  sliders.forEach((slider) => initDragToScroll(slider));
});

// --------- Draggable JS ---------

// --------- DEV 05 ----------------




// ---for mobile view buy button top z-index--don't use this code-

// document.addEventListener("DOMContentLoaded", function () {
//   if (window.innerWidth <= 950) {
//     const button = document.querySelector(".c-buy-button");
//     if (!button) return;

//     // document.body.appendChild(button); 

//     const style = document.createElement("style");
//     style.textContent = `
//       .c-buy-button {
//         z-index: 2147483647 !important;
//       }
//     `;
//     document.head.appendChild(style);
//   }
// });

// ---for mobile view buy button top z-index---
